import { useFormContext } from "react-hook-form";
import { SchemaOutput, SHORT_DESCRIPTION_MAX_SIZE } from "./schema";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  OptionalLabel,
} from "@/kit/ui/form";
import { FormattedMessage, useIntl } from "react-intl";
import { Textarea } from "@/kit/ui/textarea";
import TagInput from "../TagInput";
import { Combobox } from "@/kit/ui/combobox";
import { LICENSES } from "@/utils/license";
import { assumeNullish } from "@/utils/helpers";

export function WorkspaceMetadataEditForm() {
  const intl = useIntl();
  const form = useFormContext<SchemaOutput>();

  return (
    <>
      <FormField
        control={form.control}
        name="shortDescription"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="Short description" />
              <OptionalLabel />
            </FormLabel>
            <FormControl>
              <Textarea
                maxLength={SHORT_DESCRIPTION_MAX_SIZE + 1}
                placeholder={intl.formatMessage({
                  defaultMessage: "Add description",
                })}
                onPointerDown={(e) => e.stopPropagation()}
                {...field}
              />
            </FormControl>

            {!fieldState.error && (
              <FormDescription>
                <FormattedMessage
                  defaultMessage="{count}/{maxChar} characters used"
                  values={{
                    count: assumeNullish(field.value)?.length,
                    maxChar: SHORT_DESCRIPTION_MAX_SIZE,
                  }}
                />
              </FormDescription>
            )}

            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="tags"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="Categories" />
              <OptionalLabel />
            </FormLabel>
            <FormControl>
              <TagInput
                activityKind="WORKSPACE"
                placeholder={intl.formatMessage({
                  defaultMessage: "Add categories",
                })}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="license"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="License" />
              <OptionalLabel />
            </FormLabel>
            <FormControl>
              <Combobox
                items={LICENSES.map((license) => ({
                  value: license,
                  label: license,
                }))}
                emptyMessage={intl.formatMessage({
                  defaultMessage: "No license found",
                })}
                placeholder={intl.formatMessage({
                  defaultMessage: "Add license",
                })}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
